export default __webpack_public_path__ + "static/media/thumbnail.00fbaac2.jpeg";